module.exports = __webpack_public_path__ + "img/orangedown-white.8edc46c3.png";